module.exports = __webpack_public_path__ + "static/img/wl-xc-img.683e25c9.png";